import { Component } from 'react'

import { Input } from 'components/ideal-core-ui'

class InputContainer extends Component {
  updateText = event => {
    const { value } = event.target
    if (this.props.allowWhitespace) {
      this.props.cb(value)
    } else if (value.trim() || value === '') {
      this.props.cb(value)
    }
  }

  render() {
    return (
      <Input
        {...this.props}
        text={this.props.text}
        onChangeCb={this.updateText}
        isDisabled={this.props.isDisabled}
        cy={this.props.cy}
      />
    )
  }
}

export default InputContainer
